import { render, staticRenderFns } from "./OrderDigitalGifts.vue?vue&type=template&id=981aee18&scoped=true&"
import script from "./OrderDigitalGifts.vue?vue&type=script&lang=js&"
export * from "./OrderDigitalGifts.vue?vue&type=script&lang=js&"
import style0 from "./OrderDigitalGifts.vue?vue&type=style&index=0&id=981aee18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981aee18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VSlider})
